// 简体中文
const userModule = {
  user: "我的",
  userName: "用户名",
  userInfo: "用户信息",
  phone: "电话",
  sex: "性别",
  updatePassword: "修改密码",
  myOrder: "我的订单",
  myCoupon:"优惠券",
  aboutService: "关于这个服务",
  rule1: "利用规约",
  rule2: "保护方针",
  returnLogin: "退出登录",
  sex0: "保密",
  sex1: "男",
  sex2: "女",
  email: "邮箱",
};
export default userModule;
